import HeadsetLargeIcon from '../../assets/icons/headset-large.svg?react';
import { FC } from 'react';

import { Modal } from '../molecules/Modal';

type SupportModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SupportModal: FC<SupportModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} panelClassName="!w-fit">
      <div className="flex h-full flex-col items-center justify-center gap-[32px] p-[16px] md:w-[500px] md:p-[40px]">
        <div className="flex size-[64px] items-center gap-3 rounded-[100px] bg-[#0788F1]/10 p-[16px]">
          <HeadsetLargeIcon className="size-[32px]" />
        </div>
        <p className="text-center text-[1rem] font-normal leading-6 tracking-normal text-[#151515]">
          Если у вас возникли трудности или вопросы по работе сервиса - вы
          можете позвонить по телефону горячей линии или написать в чат нашему
          специалисту
        </p>
        <div className="flex w-[322px] flex-col gap-[12px] md:w-auto">
          <a
            href="https://t.me/paxcare_bot"
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center rounded-[12px] bg-[#0788f1] p-[20px] text-center text-base font-bold leading-[125%] text-white transition-opacity hover:opacity-90 md:w-[420px]"
            style={{
              fontFamily: 'var(--font-family)',
            }}
          >
            Написать специалисту
          </a>
          <button
            type="button"
            onClick={() => {
              window.location.href = 'tel:+74950062157';
            }}
            className="mdw-[420px] flex w-full items-center justify-center rounded-[12px] bg-[#ecf7fe] p-[20px] text-center text-base font-bold leading-[125%] text-[#0788f1] transition-opacity hover:opacity-90"
            style={{
              fontFamily: 'var(--font-family)',
            }}
          >
            Позвонить +7 (495) 006 21 57
          </button>
        </div>
      </div>
    </Modal>
  );
};
